import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Observable } from "rxjs";

@Component({
  selector: 'app-perform-answer-dialog',
  templateUrl: './perform-answer-dialog.component.html',
  styleUrls: ['./perform-answer-dialog.component.css']
})
export class PerformAnswerDialogComponent implements OnInit {

  performLoading: boolean;
  performInvite: any;
  errorMessage: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<PerformAnswerDialogComponent>) { }

  ngOnInit() {
    this.performInvite = this.data.performInvite;
    console.log(this.performInvite);
    console.log(this.performInvite.perform.items);
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/perform-answer-dialog/perform-answer-dialog.component.ts